module.exports = __webpack_public_path__ + "web/img/mvp-img3.b7c843b8.png";